/**
 * @voltxampere/ui — 2N3906 PNP BJT variant (Sprint 38-1)
 *
 * Reference: onsemi NSC5 datasheet 2N3906 (TO-92 PNP complement to
 * 2N3904).
 *   Is = 1.4e-15 A
 *   Bf = 200            (lower than NPN 2N3904's 300)
 *   Vaf = 18 V          (lower output resistance — typical PNP trade)
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { pnp } from "../pnp.js";
export const bjtPnp2n3906 = {
    id: "2n3906",
    nameTr: "2N3906 (PNP, TO92)",
    nameEn: "2N3906 (PNP, TO92)",
    shortcut: "Q",
    category: "active",
    viewBox: pnp.viewBox,
    terminals: pnp.terminals,
    defaultLabel: "Q",
    defaultValue: "2N3906",
    schemaType: "bjt-pnp",
    defaultParams: { Is: 1.4e-15, Bf: 200, Vaf: 18 },
    renderSVG: () => pnp.renderSVG(),
};
//# sourceMappingURL=bjt-pnp-2n3906.js.map